import React from 'react'
import styled from 'styled-components'

import { color } from 'definition'

const LoadingIcon = (props) => {
  const { loading = false } = props

  const icon = loading ? <Icon /> : undefined
  return <span>{icon}</span>
}

const Icon = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid ${color.font};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 2s linear infinite;
  margin: 0 auto;

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default LoadingIcon
